module.exports = __webpack_public_path__ + "img/img_size6_hc.3695e547.png";